import { Filter } from 'components/molecules/filters/types';
import { EXTRA_DETAILS } from 'constant';
import { getReducer, getSeed } from './combiner';
import { FilterFunction, toFilterFunction } from './filter-functions';
import { FieldFilter } from './filters';
import { GroupedFilter } from './grouped-filter-popover';

export const getFilterFunction = (filter: Filter): FilterFunction | null =>
  filter.criteria.filter((x) => FieldFilter.isValid(x)).length === 0
    ? null
    : filter.criteria
        .filter((x) => FieldFilter.isValid(x))
        .map((criterion) => toFilterFunction(criterion))
        .reduce(getReducer(filter.type), getSeed(filter.type));

export const getGroupedFilterFunction = (
  filter: GroupedFilter,
): FilterFunction | null =>
  filter.groupCriteria.filter(({ criteria }) => FieldFilter.isValid(criteria))
    .length === 0
    ? null
    : filter.groupCriteria
        .filter(({ criteria }) => FieldFilter.isValid(criteria))
        .map(
          ({ id, criteria }) =>
            (record) =>
              id === filter.defaultGroup
                ? toFilterFunction(criteria)(record)
                : toFilterFunction(criteria)(record?.[EXTRA_DETAILS]?.[id]),
        )
        .reduce(getReducer(filter.type), getSeed(filter.type));
